module.exports = __webpack_public_path__ + "Roboto-Condensed-Bold.2db30326d4e412709a97.svg";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Condensed-Bold.svg
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Condensed-Bold.svg
// module chunks = styles